"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDisplayError = formatDisplayError;
function stringifyUnknown(value) {
  if (typeof value === 'string') return value;
  if (value instanceof Error) return value.message || value.name;
  if (value == null) return '';
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}
function formatDisplayError(error, fallbackMessage) {
  return (fallbackMessage || stringifyUnknown(error) || 'Something went wrong.').trim();
}